import { useChainId } from 'wagmi';
import { env } from '../utils/envs';

export const useAccountChainIdOrDefault = () => {
  const chainId = useChainId();
  // Base Sepolia Testnet
  return chainId ?? env.VITE_DEFAULT_CHAIN_ID;
};
